import { fromEvent, merge } from 'rxjs'
import { mergeMap, map, takeUntil, debounceTime } from 'rxjs/operators'

export const Swipe = {
    name: 'swipe',
    config: {
        options: {
            swipe: true
        }
    },
    setupEvents: {
        order: 0,
        fnc: setupEvents
    }
}

function setupEvents() {
    if (!this.config.options.swipe) {
        return
    }

    const down = merge(
        // fromEvent(this.elements.viewport, 'mousedown'),
        fromEvent(this.elements.viewport, 'touchstart')
    )

    const move = merge(
        // fromEvent(window, 'mousemove'),
        fromEvent(window, 'touchmove')
    )

    const up = merge(
        fromEvent(window, 'dragend'),
        // fromEvent(window, 'mouseup'),
        fromEvent(window, 'touchend'),
        fromEvent(window, 'touchcancel')
    )

    down.pipe(
        mergeMap((downEvt) => {
            const downX = getXCoord(downEvt)

            return move.pipe(
                map((moveEvt) => {
                    const moveX = getXCoord(moveEvt)
                    const diff = moveX - downX
                    return diff < 0
                        ? this.config.options.slidesToScroll
                        : -this.config.options.slidesToScroll
                }),
                takeUntil(up)
            )
        }),
        debounceTime(50)
    ).subscribe((increment) => {
        this.bus.triggers.incrementSlide.next(increment)
        this.state.slideChangeTrigger = 'swipe'
    })
}

function getXCoord(evt) {
    if (evt.touches && evt.touches.length) {
        return evt.touches[0].clientX
    }

    return evt.clientX
}
